module.exports = __webpack_public_path__ + "img/down.ca5376b5.png";